var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CarContainer',{attrs:{"title":"IN SHOP","cars":this.cars}})}
var staticRenderFns = []

export { render, staticRenderFns }